var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComposition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,12h-2c-.552,0-1-.448-1-1s.448-1,1-1h2c.552,0,1,.448,1,1s-.448,1-1,1Zm1,4c0-.552-.448-1-1-1h-4c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1Zm4,3V7c0-2.757-2.243-5-5-5h-.171c-.413-1.164-1.525-2-2.829-2h-2c-1.304,0-2.416,.836-2.829,2h-.171c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h8c2.757,0,5-2.243,5-5ZM9,4c.552,0,1-.448,1-1s.449-1,1-1h2c.551,0,1,.449,1,1s.448,1,1,1h1c1.654,0,3,1.346,3,3v12c0,1.654-1.346,3-3,3H8c-1.654,0-3-1.346-3-3V7c0-1.654,1.346-3,3-3h1Zm-1,11c-.552,0-1,.448-1,1s.448,1,1,1,1-.448,1-1-.448-1-1-1Zm1.834-3.477l1.862-1.805c.397-.385,.407-1.018,.022-1.414-.385-.397-1.018-.406-1.414-.022l-1.64,1.59-.811-.766c-.401-.379-1.034-.362-1.414,.041-.379,.402-.361,1.035,.041,1.414l1.008,.951c.314,.315,.733,.488,1.178,.488s.864-.173,1.167-.477Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposition);
export default __webpack_public_path__ + "static/media/composition.b7361a2c21b4655926e05402eb12c73e.svg";
export { ForwardRef as ReactComponent };